import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { onChangeAction, onSubmitForm, toggleModal } from "../../../../../redux/modals/modal-inline-mod-check/actionModal";

const ModalFooter = () => {
    const dispatch = useDispatch();
    
    // Оптимизированный селектор с деструктуризацией
    const { close, save_changes } = useSelector((state) => 
        state.lots.phrases
    );

    // Мемоизация обработчика закрытия модального окна
    const handleCloseModal = useCallback(() => {
        dispatch(onChangeAction());
        dispatch(toggleModal(false));
    }, [dispatch]);

    // Мемоизация обработчика отправки формы
    const handleSubmitForm = useCallback(() => {
        dispatch(onSubmitForm());
    }, [dispatch]);

    return (
        <div className="modal-footer">
            <button 
                type="button" 
                onClick={handleCloseModal}
                className="btn btn-secondary btn-sm me-2"
            >
                {close}
            </button>
            <button 
                type="button" 
                onClick={handleSubmitForm} 
                className="btn btn-primary btn-sm btn-rg"
            >
                {save_changes}
            </button>
        </div>
    );
};

export default ModalFooter;